import React from 'react';
import { useCarouselContext } from '../CarouselProvider/CarouselProvider';
import { DotsStyles as S } from './Dots.styles';
const Dots = ({ activeIndex, itemCount }) => {
    const carousel = useCarouselContext();
    return (React.createElement(S.Dots, null, Array.from(Array(itemCount)).map((_, index) => (React.createElement(S.Dot, { key: `dot-${index}`, "aria-label": `Go to slide ${index + 1}`, "data-active": index == activeIndex, onClick: () => carousel.goToIndex(index) })))));
};
export default Dots;
